/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeightResponseDto
 */
export interface WeightResponseDto {
    /**
     * Identity of the Weight observation
     * @type {string}
     * @memberof WeightResponseDto
     */
    observationId: string;
    /**
     * Weight value
     * @type {number}
     * @memberof WeightResponseDto
     */
    value?: number;
    /**
     * Weight unit
     * @type {string}
     * @memberof WeightResponseDto
     */
    unit?: WeightResponseDtoUnitEnum;
}


/**
 * @export
 */
export const WeightResponseDtoUnitEnum = {
    Kg: 'kg',
    Lbs: 'lbs'
} as const;
export type WeightResponseDtoUnitEnum = typeof WeightResponseDtoUnitEnum[keyof typeof WeightResponseDtoUnitEnum];


/**
 * Check if a given object implements the WeightResponseDto interface.
 */
export function instanceOfWeightResponseDto(value: object): value is WeightResponseDto {
    if (!('observationId' in value) || value['observationId'] === undefined) return false;
    return true;
}

export function WeightResponseDtoFromJSON(json: any): WeightResponseDto {
    return WeightResponseDtoFromJSONTyped(json, false);
}

export function WeightResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeightResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'observationId': json['observationId'],
        'value': json['value'] == null ? undefined : json['value'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function WeightResponseDtoToJSON(json: any): WeightResponseDto {
    return WeightResponseDtoToJSONTyped(json, false);
}

export function WeightResponseDtoToJSONTyped(value?: WeightResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'observationId': value['observationId'],
        'value': value['value'],
        'unit': value['unit'],
    };
}

